var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.85 9.03833C16.85 13.4566 13.2683 17.0383 8.84998 17.0383C4.4317 17.0383 0.849976 13.4566 0.849976 9.03833C0.849976 4.62005 4.4317 1.03833 8.84998 1.03833C13.2683 1.03833 16.85 4.62005 16.85 9.03833Z",
    fill: "#FAE6E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85 1.88823C4.90116 1.88823 1.7 5.0894 1.7 9.03823C1.7 12.9871 4.90116 16.1882 8.85 16.1882C12.7988 16.1882 16 12.9871 16 9.03823C16 5.0894 12.7988 1.88823 8.85 1.88823ZM0 9.03823C0 4.15051 3.96228 0.188232 8.85 0.188232C13.7377 0.188232 17.7 4.15051 17.7 9.03823C17.7 13.926 13.7377 17.8882 8.85 17.8882C3.96228 17.8882 0 13.926 0 9.03823Z",
    fill: "#A51713"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85007 8.18823C9.31952 8.18823 9.70007 8.56879 9.70007 9.03823L9.70007 12.0382C9.70007 12.5077 9.31952 12.8882 8.85007 12.8882C8.38063 12.8882 8.00007 12.5077 8.00007 12.0382L8.00007 9.03823C8.00007 8.56879 8.38063 8.18823 8.85007 8.18823Z",
    fill: "#A51713"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84998 6.03833C9.84998 6.59061 9.40226 7.03833 8.84998 7.03833C8.29769 7.03833 7.84998 6.59061 7.84998 6.03833C7.84998 5.48605 8.29769 5.03833 8.84998 5.03833C9.40226 5.03833 9.84998 5.48605 9.84998 6.03833Z",
    fill: "#A51713"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.be80aee47156c88417f5f67a333b5e96.svg";
export { ForwardRef as ReactComponent };